import styled, { useTheme } from 'styled-components';

export const Triangle: React.FC<React.SVGProps<SVGPathElement>> = (props) => (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 7L0.5 13.0622L0.5 0.937822L11 7Z" {...props} />
  </svg>
);

export const TickTriangle: React.FC<{ positive: boolean; className?: string }> = ({ positive, className }) => {
  const theme = useTheme();
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.5 12L0.00480938 0.75L12.9952 0.75L6.5 12Z" fill={positive ? theme.legacy.green : theme.legacy.red} />
    </svg>
  );
};

interface FloatingTickProps {
  daySpacing: number;
  day: number;
  elementWidth: number;
}

export const S = {
  Container: styled.div`
    background-color: #e4ebef;
    border-radius: 4px;
    min-height: 92px;
    padding: 16px 23px;
    position: relative;

    @media (max-width: 800px) {
      box-sizing: border-box;
      overflow-y: scroll;
      width: 686px;
    }
  `,
  LoadingMessage: styled.div`
    color: ${(props) => props.theme.algoanBlue};
    padding: 9px;
  `,
  Error: styled.div`
    color: ${(props) => props.theme.legacy.danger};
  `,
  Axis: styled.div<{ hide: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    opacity: ${(props) => (props.hide ? '0' : '1')};
  `,
  Bar: styled.div`
    background-color: ${(props) => props.theme.legacy.secondary};
    height: 3px;
    width: 100%;
    margin-right: -1px;
  `,
  Ticks: styled.div<{ hide: boolean }>`
    margin-top: -6px;
    min-height: 31px;
    position: relative;
    opacity: ${(props) => (props.hide ? '0' : '1')};
  `,
  Tick: styled.div.attrs<FloatingTickProps>((props) => ({
    style: { left: props.daySpacing * props.day - props.elementWidth / 2 },
  }))<FloatingTickProps>`
    align-items: center;
    display: flex;
    flex-direction: column;
    position: absolute;
  `,
  TickBar: styled.div`
    background-color: ${(props) => props.theme.legacy.secondary};
    height: 18px;
    width: 1px;
  `,
  TickLabel: styled.div`
    color: ${(props) => props.theme.legacy.secondary};
    font-size: 10px;
    height: 13px;
    line-height: 13px;
    min-width: 51px;
  `,
  Events: styled.div<{ levels: number }>`
    height: ${(props) => props.levels * 14.4 + 12}px;
    min-height: 55px;
    margin-bottom: -3px;
    position: relative;
  `,
  Event: styled.div.attrs<FloatingTickProps>((props) => ({
    style: { left: props.daySpacing * props.day - props.elementWidth / 2 },
  }))<FloatingTickProps>`
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: column;
    position: absolute;
  `,
  EventLabel: styled.div`
    color: ${(props) => props.theme.algoanBlue};
    font-size: 11px;
    font-weight: bold;
    line-height: 14px;
    max-width: 120px;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    text-transform: capitalize;
    white-space: nowrap;
    z-index: 2;

    &:hover {
      text-overflow: initial;
      overflow: visible;
      z-index: 3;

      + div {
        z-index: 3;
      }
    }
  `,
  EventSpacer: styled.div<{ level: number }>`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: ${(props) => props.level * 12 + 1}px;
    justify-content: space-around;
  `,
  EventDot: styled.div<{ positive: boolean }>`
    background-color: ${(props) => (props.positive ? props.theme.legacy.green : props.theme.legacy.red)};
    height: 4px;
    margin: auto 0;
    width: 2px;
  `,
  EventTick: styled(TickTriangle)<{ level: number }>`
    margin-bottom: ${(props) => props.level * 12 + (props.level === 0 ? 0 : 3)}px;
  `,
  EventDate: styled.div`
    color: ${(props) => props.theme.algoanBlue};
    font-size: 10px;
    height: 13px;
    line-height: 13px;
    position: absolute;
    bottom: -21px;
  `,
};
